import React from 'react';
import { motion } from 'framer-motion';
import { Check, Download, Shield, Gem, Compass, MessageCircle, Target, Unlock, Clock, ArrowRight, Flag, Sparkles, Heart, Eye, Hand, Mail, Headphones, Gift, ShieldCheck, Zap, Lock, ExternalLink, UserPlus, CreditCard, FileDown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PurchaseSection() {
  const features = ['Acceso inmediato tras la compra', 'Formato digital descargable (PDF)', 'Compatible con todos los dispositivos', 'Garantía de satisfacción 7 días'];
  const bonusPreviews = [{
    name: 'Microgestos Femeninos Que Reviven la Intimidad',
    img: 'https://cdn.magicpatterns.com/uploads/qM9NagPqEtdo9WmnMGC3Qy/BONO_1.png'
  }, {
    name: 'El Decálogo del Matrimonio Inquebrantable',
    img: 'https://cdn.magicpatterns.com/uploads/cAs3Yzsryo5NzYTE7nSnxQ/BONO_2.png'
  }, {
    name: 'Red Flags Emocionales Que Están Apagando Tu Matrimonio',
    img: 'https://cdn.magicpatterns.com/uploads/cgSMJGzdQZfBD2a1cuL1e8/BONO_3.png'
  }];
  const steps = [{
    icon: ExternalLink,
    text: 'Se abre Hotmart (serás redirigida a la plataforma internacional de pagos)'
  }, {
    icon: UserPlus,
    text: 'Ingresas email + nombre'
  }, {
    icon: CreditCard,
    text: 'Pagas (tarjeta crédito/débito/PayPal)'
  }, {
    icon: FileDown,
    text: 'Recibes el PDF al instante + correo con enlace'
  }, {
    icon: ShieldCheck,
    text: 'Garantía 7 días + Soporte por email'
  }];
  return <section id="purchase-section" className="py-8 md:py-12 bg-gradient-to-b from-white to-[#faf8f6] scroll-mt-20" style={{
    paddingTop: '4px',
    paddingBottom: '4px'
  }} data-id="element-277">
      <div className="max-w-6xl mx-auto px-6" data-id="element-278">
        {/* Main Purchase Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-279">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-[#2d2d2d] mb-2" data-id="element-280">
            Comienza Tu Transformación Hoy
          </h2>
          <p className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-[#9d4b6b] mb-3" data-id="element-281">
            El Divorcio Emocional
          </p>
          <p className="text-lg md:text-xl text-[#5a5a5a] max-w-2xl mx-auto" data-id="element-282">
            Empieza a reconectar con tu esposo desde hoy mismo.
          </p>
        </motion.div>

        {/* Price Card Section */}
        <div id="offer-price" className="grid lg:grid-cols-2 gap-12 items-center mb-20 scroll-mt-20" data-id="element-283">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative" data-id="element-284">
            {/* OFERTA ESPECIAL DE LANZAMIENTO - Banner style */}
            <div className="bg-[#9d4b6b] text-white text-center py-3 px-6 rounded-lg shadow-lg mb-6 transform -rotate-1 mx-auto max-w-md" data-id="element-285">
              <p className="font-serif font-bold text-lg md:text-xl uppercase tracking-wider flex items-center justify-center gap-2" data-id="element-286">
                <Heart className="w-5 h-5 fill-white text-white" style={{
                animation: 'heartbeat 1.4s ease-in-out infinite'
              }} data-id="element-287" />
                Oferta Especial de Lanzamiento
                <Heart className="w-5 h-5 fill-white text-white" style={{
                animation: 'heartbeat 1.4s ease-in-out infinite'
              }} data-id="element-288" />
              </p>
            </div>

            <div className="relative z-10" data-id="element-289">
              <img src="https://cdn.magicpatterns.com/uploads/ov3p2HwiasmdJmV66Uy3et/MOCKUP_DIVORCIO_EMOCIONAL.png" alt="El Divorcio Emocional en múltiples dispositivos" className="w-full h-auto" data-id="element-290" />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] bg-[#9d4b6b]/5 rounded-full blur-3xl -z-10" data-id="element-291" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white p-8 md:p-12 rounded-3xl shadow-2xl shadow-[#9d4b6b]/10 border border-[#d4a5a5]/20" style={{
          paddingTop: '18px',
          paddingBottom: '18px'
        }} data-id="element-292">
            <div className="mb-8" data-id="element-293">
              <div className="flex items-baseline gap-2 mb-2" data-id="element-294">
                <span className="text-5xl md:text-6xl font-bold text-[#9d4b6b]" data-id="element-295">
                  $12.99
                </span>
                <span className="text-xl text-[#8b6f6f] line-through" data-id="element-296">
                  $49.99
                </span>
              </div>
              <p className="text-[#5a5a5a] flex items-center gap-2" data-id="element-297">
                <Shield className="w-4 h-4 text-[#9d4b6b]" data-id="element-298" />
                Oferta especial por tiempo limitado
              </p>
            </div>

            <ul className="space-y-4 mb-6" data-id="element-299">
              {features.map((feature, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.5 + index * 0.1
            }} className="flex items-start gap-3 text-[#5a5a5a]" data-id="element-300">
                  <div className="mt-1 min-w-[20px]" data-id="element-301">
                    <Check className="w-5 h-5 text-[#9d4b6b]" data-id="element-302" />
                  </div>
                  <span data-id="element-303">{feature}</span>
                </motion.li>)}
            </ul>

            {/* Bonus previews before CTA */}
            <div className="bg-[#faf8f6] rounded-xl p-4 mb-6 border border-[#d4a5a5]/20" data-id="element-304">
              <p className="text-[#9d4b6b] font-bold text-sm mb-3 flex items-center gap-2" data-id="element-305">
                <Gift className="w-4 h-4" data-id="element-306" />+ 3 Bonos GRATIS (Valor $79)
              </p>
              <div className="space-y-3" data-id="element-307">
                {bonusPreviews.map((bonus, index) => <div key={index} className="flex items-start gap-3" data-id="element-308">
                    <img src={bonus.img} alt={bonus.name} className="w-12 h-12 rounded-lg object-cover shadow-sm flex-shrink-0" data-id="element-309" />
                    <span className="text-[#5a5a5a] text-sm font-medium leading-tight mt-1" data-id="element-310">
                      {bonus.name}
                    </span>
                  </div>)}
              </div>
            </div>

            <CTAButton fullWidth className="mb-4" data-id="element-311">
              Obtener Acceso Ahora
            </CTAButton>

            {/* Trust badges below CTA */}
            <div className="grid grid-cols-3 gap-3 mt-4" data-id="element-312">
              <div className="flex flex-col items-center text-center gap-1.5" data-id="element-313">
                <ShieldCheck className="w-6 h-6 text-[#9d4b6b]" data-id="element-314" />
                <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-315">
                  Garantía de Satisfacción 7 días
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5" data-id="element-316">
                <Zap className="w-6 h-6 text-[#9d4b6b]" data-id="element-317" />
                <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-318">
                  Descarga Inmediata
                </span>
              </div>
              <div className="flex flex-col items-center text-center gap-1.5" data-id="element-319">
                <Lock className="w-6 h-6 text-[#9d4b6b]" data-id="element-320" />
                <span className="text-xs text-[#8b6f6f] font-medium leading-tight" data-id="element-321">
                  Pago Seguro
                </span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* NEW 3-BONUS SECTION */}
        <div className="space-y-6 mb-20" data-id="element-322">
          {/* Section Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center max-w-4xl mx-auto mb-10" data-id="element-323">
            {/* BONOS EXCLUSIVOS title */}
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-324">
              <Gift className="w-8 h-8 text-[#9d4b6b]" data-id="element-325" />
              <h3 className="text-3xl md:text-4xl font-serif font-bold text-[#2d2d2d] uppercase tracking-wide" data-id="element-326">
                Bonos Exclusivos
              </h3>
              <Gift className="w-8 h-8 text-[#9d4b6b]" data-id="element-327" />
            </div>

            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-328">
              <Gem className="w-5 h-5 text-[#9d4b6b]" data-id="element-329" />
              <h4 className="text-xl md:text-2xl font-serif font-bold text-[#9d4b6b] uppercase tracking-wide" data-id="element-330">
                HOY TU COMPRA VIENE CON 3 BONOS DE LUJO
              </h4>
              <Gem className="w-5 h-5 text-[#9d4b6b]" data-id="element-331" />
            </div>
            <p className="text-xl text-[#9d4b6b] font-serif mb-6" data-id="element-332">
              (VALORADOS EN $79)… ¡TOTALMENTE GRATIS!
            </p>
            <p className="text-[#5a5a5a] leading-relaxed mb-4" data-id="element-333">
              Sabemos que tomar la decisión de sanar una relación no es fácil.
              Por eso, si entras hoy al programa{' '}
              <strong className="text-[#2d2d2d]" data-id="element-334">
                "El Divorcio Emocional"
              </strong>
              , desbloqueas automáticamente el acceso a 3 bonos premium
              diseñados para ayudarte a reconectar desde el primer día, sin
              terapia, sin confrontación y sin contarle a nadie.
            </p>
            <p className="text-[#2d2d2d] font-bold text-sm bg-[#9d4b6b]/10 inline-block px-6 py-3 rounded-xl border border-[#9d4b6b]/30" data-id="element-335">
              Estos bonos no están a la venta por separado. Son tu regalo
              exclusivo por actuar HOY.
            </p>
          </motion.div>

          {/* BONO #1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#9d4b6b] to-[#8b6f6f] p-[2px] rounded-3xl" data-id="element-336">
            <div className="bg-white rounded-[22px] p-8 md:p-10 overflow-hidden" data-id="element-337">
              <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-338">
                <div className="order-2 lg:order-1" data-id="element-339">
                  <h4 className="text-2xl md:text-3xl font-serif text-[#2d2d2d] mb-2" data-id="element-340">
                    Microgestos Femeninos Que Reviven la Intimidad
                  </h4>
                  <p className="text-[#8b6f6f] font-medium mb-4" data-id="element-341">
                    Guía práctica de 7 días para reactivar la conexión emocional
                  </p>
                  <div className="flex items-center gap-3 mb-6 text-sm" data-id="element-342">
                    <span className="text-[#2d2d2d] font-bold text-base line-through decoration-red-500 decoration-[3px]" data-id="element-343">
                      Valor real: $27
                    </span>
                    <span className="text-white font-extrabold bg-[#9d4b6b] px-4 py-1.5 rounded-full shadow-md text-base" data-id="element-344">
                      Hoy: GRATIS
                    </span>
                  </div>

                  <p className="text-[#2d2d2d] font-medium mb-4 italic" data-id="element-345">
                    ¿Te cuesta acercarte sin que él se aleje más?
                  </p>
                  <p className="text-[#5a5a5a] mb-6 leading-relaxed" data-id="element-346">
                    Este bono es tu puente invisible para recuperar la
                    complicidad sin tener que hablar de más, ni forzar
                    conversaciones incómodas. Solo necesitas aplicar microgestos
                    diarios —como una mirada suave, un toque ligero o una nota
                    escrita— que despiertan ternura, confianza y cercanía, sin
                    pedir nada a cambio.
                  </p>

                  <div className="bg-[#faf8f6] p-5 rounded-xl border-l-4 border-[#9d4b6b] mb-6" data-id="element-347">
                    <div className="flex items-start gap-3 mb-3" data-id="element-348">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-349" />
                      <p className="text-sm text-[#5a5a5a]" data-id="element-350">
                        Ideal si piensas: "Ya no sé cómo acercarme…"
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-351">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-352" />
                      <p className="text-sm text-[#5a5a5a]" data-id="element-353">
                        Lo usas en 2 minutos al día. Sin presión. Solo
                        intención.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 text-[#9d4b6b] text-sm" data-id="element-354">
                    <Download className="w-4 h-4 flex-shrink-0" data-id="element-355" />
                    <span className="font-extrabold" data-id="element-356">
                      Lo descargas gratis al acceder hoy al programa.
                    </span>
                  </div>
                </div>

                <div className="order-1 lg:order-2 relative" data-id="element-357">
                  <h3 className="text-3xl md:text-4xl font-extrabold font-serif text-[#9d4b6b] text-center mb-4 uppercase tracking-wide flex items-center justify-center gap-3" data-id="element-358">
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-359" />
                    BONO #1
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-360" />
                  </h3>
                  <div className="relative z-10 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-361">
                    <img src="https://cdn.magicpatterns.com/uploads/qM9NagPqEtdo9WmnMGC3Qy/BONO_1.png" alt="Bono 1: Microgestos Femeninos" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-362" />
                  </div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#9d4b6b]/20 rounded-full blur-3xl -z-10" data-id="element-363" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* BONO #2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#9d4b6b] to-[#8b6f6f] p-[2px] rounded-3xl" data-id="element-364">
            <div className="bg-white rounded-[22px] p-8 md:p-10 overflow-hidden" data-id="element-365">
              <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-366">
                <div className="order-1 relative" data-id="element-367">
                  <h3 className="text-3xl md:text-4xl font-extrabold font-serif text-[#9d4b6b] text-center mb-4 uppercase tracking-wide flex items-center justify-center gap-3" data-id="element-368">
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-369" />
                    BONO #2
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-370" />
                  </h3>
                  <div className="relative z-10 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-371">
                    <img src="https://cdn.magicpatterns.com/uploads/cAs3Yzsryo5NzYTE7nSnxQ/BONO_2.png" alt="Bono 2: El Decálogo del Matrimonio Inquebrantable" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-372" />
                  </div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#9d4b6b]/20 rounded-full blur-3xl -z-10" data-id="element-373" />
                </div>

                <div className="order-2" data-id="element-374">
                  <h4 className="text-2xl md:text-3xl font-serif text-[#2d2d2d] mb-2" data-id="element-375">
                    El Decálogo del Matrimonio Inquebrantable
                  </h4>
                  <p className="text-[#8b6f6f] font-medium mb-4" data-id="element-376">
                    10 acuerdos emocionales para reconstruir tu relación sin
                    terapia
                  </p>
                  <div className="flex items-center gap-3 mb-6 text-sm" data-id="element-377">
                    <span className="text-[#2d2d2d] font-bold text-base line-through decoration-red-500 decoration-[3px]" data-id="element-378">
                      Valor real: $29
                    </span>
                    <span className="text-white font-extrabold bg-[#9d4b6b] px-4 py-1.5 rounded-full shadow-md text-base" data-id="element-379">
                      Hoy: GRATIS
                    </span>
                  </div>

                  <p className="text-[#5a5a5a] mb-6 leading-relaxed" data-id="element-380">
                    No sabes por dónde empezar… pero sabes que algo tiene que
                    cambiar. Este decálogo imprimible te entrega 10 acuerdos
                    prácticos, amorosos y claros que puedes aplicar sin
                    confrontar ni exponer tu relación.{' '}
                    <strong className="text-[#2d2d2d]" data-id="element-381">Incluye:</strong>
                  </p>

                  <ul className="space-y-3 mb-6" data-id="element-382">
                    <li className="flex items-start gap-3" data-id="element-383">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-384" />
                      <span className="text-[#5a5a5a] text-sm" data-id="element-385">
                        Cómo decirlo suavemente sin generar rechazo.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-386">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-387" />
                      <span className="text-[#5a5a5a] text-sm" data-id="element-388">
                        Un microgesto diario para activar el cambio.
                      </span>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-389">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-390" />
                      <span className="text-[#5a5a5a] text-sm" data-id="element-391">
                        Qué evitar para no sabotear el avance.
                      </span>
                    </li>
                  </ul>

                  <div className="bg-[#faf8f6] p-4 rounded-xl mb-6 flex items-start gap-3" data-id="element-392">
                    <Compass className="w-5 h-5 text-[#9d4b6b] mt-1 flex-shrink-0" data-id="element-393" />
                    <p className="text-sm text-[#5a5a5a] italic" data-id="element-394">
                      Ideal si piensas: "No tengo tiempo, él se enoja si hablo,
                      y no quiero exponerme."
                    </p>
                  </div>

                  <div className="flex items-center gap-2 text-[#9d4b6b] text-sm" data-id="element-395">
                    <Download className="w-4 h-4 flex-shrink-0" data-id="element-396" />
                    <span className="font-extrabold" data-id="element-397">
                      Lo recibes como regalo exclusivo solo por entrar hoy.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* BONO #3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#9d4b6b] to-[#8b6f6f] p-[2px] rounded-3xl" data-id="element-398">
            <div className="bg-white rounded-[22px] p-8 md:p-10 overflow-hidden" data-id="element-399">
              <div className="grid lg:grid-cols-2 gap-10 items-center" data-id="element-400">
                <div className="order-2 lg:order-1" data-id="element-401">
                  <h4 className="text-2xl md:text-3xl font-serif text-[#2d2d2d] mb-2" data-id="element-402">
                    Red Flags Emocionales Que Están Apagando Tu Matrimonio
                  </h4>
                  <p className="text-[#8b6f6f] font-medium mb-4" data-id="element-403">
                    Checklist profesional para detectar señales invisibles de
                    desconexión
                  </p>
                  <div className="flex items-center gap-3 mb-6 text-sm" data-id="element-404">
                    <span className="text-[#2d2d2d] font-bold text-base line-through decoration-red-500 decoration-[3px]" data-id="element-405">
                      Valor real: $23
                    </span>
                    <span className="text-white font-extrabold bg-[#9d4b6b] px-4 py-1.5 rounded-full shadow-md text-base" data-id="element-406">
                      Hoy: GRATIS
                    </span>
                  </div>

                  <p className="text-[#2d2d2d] font-medium mb-4 italic" data-id="element-407">
                    ¿No estás segura si tu matrimonio está en crisis… o solo es
                    una etapa?
                  </p>
                  <p className="text-[#5a5a5a] mb-6 leading-relaxed" data-id="element-408">
                    Esta lista de 10 señales silenciosas te ayuda a ver lo que
                    no se dice pero sí se siente. Y lo mejor: por cada "red
                    flag" identificada, recibirás una acción inmediata para
                    empezar a revertirla desde hoy.
                  </p>

                  <div className="bg-[#faf8f6] p-5 rounded-xl border-l-4 border-[#9d4b6b] mb-6" data-id="element-409">
                    <div className="flex items-start gap-3 mb-3" data-id="element-410">
                      <Flag className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-411" />
                      <p className="text-sm text-[#5a5a5a]" data-id="element-412">
                        Si has dicho: "No peleamos, pero ya no nos sentimos
                        cerca…", esta guía es para ti.
                      </p>
                    </div>
                    <div className="flex items-start gap-3" data-id="element-413">
                      <Check className="w-5 h-5 text-[#9d4b6b] mt-0.5 flex-shrink-0" data-id="element-414" />
                      <p className="text-sm text-[#5a5a5a]" data-id="element-415">
                        Es directa, práctica y reveladora. Y totalmente privada.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-2 text-[#9d4b6b] text-sm" data-id="element-416">
                    <Download className="w-4 h-4 flex-shrink-0" data-id="element-417" />
                    <span className="font-extrabold" data-id="element-418">
                      Disponible gratis solo al acceder al programa ahora.
                    </span>
                  </div>
                </div>

                <div className="order-1 lg:order-2 relative" data-id="element-419">
                  <h3 className="text-3xl md:text-4xl font-extrabold font-serif text-[#9d4b6b] text-center mb-4 uppercase tracking-wide flex items-center justify-center gap-3" data-id="element-420">
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-421" />
                    BONO #3
                    <Gem className="w-7 h-7 md:w-8 md:h-8 text-[#9d4b6b]" data-id="element-422" />
                  </h3>
                  <div className="relative z-10 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-423">
                    <img src="https://cdn.magicpatterns.com/uploads/cgSMJGzdQZfBD2a1cuL1e8/BONO_3.png" alt="Bono 3: Red Flags Emocionales" className="w-full h-auto rounded-xl shadow-2xl" data-id="element-424" />
                  </div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#9d4b6b]/20 rounded-full blur-3xl -z-10" data-id="element-425" />
                </div>
              </div>
            </div>
          </motion.div>

          {/* Value Summary & Final CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-[#2d2d2d] text-white rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-426">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-427">
              <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#9d4b6b] to-transparent" data-id="element-428" />
            </div>

            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-429">
              <div className="flex items-center justify-center gap-3 mb-6" data-id="element-430">
                <Target className="w-8 h-8 text-[#d4a5a5]" data-id="element-431" />
                <h3 className="text-2xl md:text-3xl font-serif" data-id="element-432">
                  RESUMEN DE TU REGALO
                </h3>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 mb-8 border border-white/10 inline-block w-full max-w-xl" data-id="element-433">
                <p className="text-gray-300 mb-2" data-id="element-434">
                  Valor total de los 3 bonos:{' '}
                  <span className="line-through" data-id="element-435">$79</span>
                </p>
                <div className="flex items-center justify-center gap-3 text-2xl md:text-4xl font-bold text-[#d4a5a5] mb-2" data-id="element-436">
                  <Unlock className="w-6 h-6 md:w-8 md:h-8" data-id="element-437" />
                  <span data-id="element-438">TU PRECIO HOY: $0</span>
                </div>
                <p className="text-sm text-gray-400" data-id="element-439">
                  (Incluidos con tu acceso a{' '}
                  <strong data-id="element-440">"El Divorcio Emocional"</strong>)
                </p>
              </div>

              <p className="text-lg text-gray-300 mb-8 leading-relaxed" data-id="element-441">
                No necesitas rogar, forzar ni esperar que él cambie. Solo
                necesitas un mapa claro, herramientas reales… y tu decisión.
              </p>

              <div className="flex items-center justify-center gap-2 text-[#d4a5a5] mb-8 bg-[#d4a5a5]/10 py-2 px-4 rounded-full inline-flex" data-id="element-442">
                <Clock className="w-5 h-5" data-id="element-443" />
                <span className="text-sm font-medium" data-id="element-444">
                  Esta oferta especial es por tiempo limitado. Si cierras esta
                  página, puedes perder el acceso gratuito a estos bonos.
                </span>
              </div>

              <CTAButton fullWidth className="text-lg py-4" scrollToPurchase data-id="element-445">
                Únete ahora y desbloquea tus 3 bonos GRATIS
              </CTAButton>

              <p className="mt-4 text-sm text-gray-400" data-id="element-446">
                Empieza hoy tu transformación con el ebook emocional más
                completo para reconectar desde el amor, sin perderte en el
                intento.
              </p>
            </div>
          </motion.div>
        </div>

        {/* What Happens Next Section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-447">
          <div className="text-center mb-10" data-id="element-448">
            <h3 className="text-2xl md:text-3xl font-serif text-[#2d2d2d] mb-2" data-id="element-449">
              ¿Qué pasa después del clic?
            </h3>
            <div className="w-16 h-1 bg-[#9d4b6b] mx-auto rounded-full" data-id="element-450"></div>
          </div>

          <div className="grid md:grid-cols-5 gap-6 relative" data-id="element-451">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-gray-200 -z-10" data-id="element-452"></div>

            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-453">
                <div className="w-16 h-16 bg-white border-2 border-[#9d4b6b]/20 rounded-full flex items-center justify-center mb-4 shadow-sm relative z-10" data-id="element-454">
                  <step.icon className="w-7 h-7 text-[#9d4b6b]" data-id="element-455" />
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-[#9d4b6b] text-white rounded-full flex items-center justify-center text-xs font-bold" data-id="element-456">
                    {index + 1}
                  </div>
                </div>
                <p className="text-sm text-[#5a5a5a] font-medium leading-tight" data-id="element-457">
                  {step.text}
                </p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}